import { useEffect } from "react"

const FromClient = () => {
    useEffect(() => {
        localStorage.setItem("target", "client")
        window.location.href = "/"
    }, [])
}

export default FromClient
